module.exports = __webpack_public_path__ + "img/logo.2eb7985f.png";